import React from "react";
import Productpage from "../../productpage2";
import SEO from "../../seo";

export default function PostureComfortPage({ location }) {
  const data = {
    galleryImages: [
      "https://eclipsemattress.in/assets/images/products/posture-comfort/POSTURE-COMFORT-04.png",
      "https://eclipsemattress.in/assets/images/products/posture-comfort/POSTURE-COMFORT-01.png",
      "https://eclipsemattress.in/assets/images/products/posture-comfort/POSTURE-COMFORT-02.png",
      "https://eclipsemattress.in/assets/images/products/posture-comfort/POSTURE-COMFORT-03.png",
    ],
    productName: "Posture Comfort",
    productLogo:
      "https://eclipsemattress.in/wp-content/uploads/2020/01/logos-03.png",
    descriptionTitle: "",
    descriptionText:
      "Posture comfort brings together the finest quality individual Pocketed springs and a thick layer of pressure relieving, temperature sensitive Visco Elastic Memory Foam. It helps improve posture during sleep, reducing the possibility of waking you up from any pain and discomfort, guaranteeing peaceful rest throughout the night.",
    availableSizes: "7″, 7″ PT & 9 PT",

    points: [
      "Finest quality individual Pocketed Springs",
      "Pressure-relieving, temperature-sensitive Visco Elastic Memory Foam",
      "Moulds to the body’s heat, weight & position for ultimate comfort",
      "Displaces pressure and weight along the length of the body to improve circulation",
      "High quality sleep without numbing or soreness",
    ],
    category: { title: "Luxury Collection", link: "/luxury-collection" },
    featuresText: [
      "Memory Foam Soft Quilted Top",
      "HD Eclipse Plush Foam",
      "Turkish Cotton Felt",
      "Recognised by world-class chiropractors",
      "Perimeter Foam Encasement",
      "Chiropractic Bonnell Springs",
    ],
    featuresImage:
      "https://eclipsemattress.in/assets/images/products/posture-comfort/POSTURE-COMFORT-11.png",
    warrantyIcons: [
      "https://eclipsemattress.in/assets/images/products/posture-comfort/POSTURE-COMFORT-06.png",
      "https://eclipsemattress.in/assets/images/products/posture-comfort/POSTURE-COMFORT-07.png",
      "https://eclipsemattress.in/assets/images/products/posture-comfort/POSTURE-COMFORT-08.png",
      "https://eclipsemattress.in/assets/images/products/posture-comfort/POSTURE-COMFORT-09.png",
      "https://eclipsemattress.in/assets/images/products/posture-comfort/POSTURE-COMFORT-10.png",
    ],
    price: "₹26,599 - ₹87,399",
    warrantyImage:
      "https://eclipsemattress.in/assets/images/products/posture-comfort/POSTURE-COMFORT-05.png",

    relatedProducts: [
      {
        title: "Tiara Cool",
        img: "https://eclipsemattress.in/assets/images/product_thumbnails/tiara-cool.jpg",
        link: "/patent-series-mattress/tiara-cool/",
      },
      {
        title: "Accolade PT",
        img: "https://eclipsemattress.in/assets/images/product_thumbnails/accolade-pt.jpg",
        link: "/patent-series-mattress/accolade-pt/",
      },
      {
        title: "Healthsense ET",
        img: "https://eclipsemattress.in/assets/images/product_thumbnails/healthsense-et.jpg",
        link: "/patent-series-mattress/healthsense-et/",
      },
    ],
  };

  return (
    <div>
      <SEO
        title="Posture Comfort Memory Foam Mattress | Eclipse International"
        description="Buy posture comfort memory foam mattress with 10 years warranty from Eclipse International bringing finest quality pocketed springs and pressure relieving. Good for people who have long sitting hours at work"
        img="https://eclipsemattress.in/assets/linkpreviews/link-preview-posturecomfort.jpg"
      />
      <Productpage location={location} product={data} />
    </div>
  );
}
